import { useState, type MouseEvent } from 'react';
import { stopPropagation } from '../utils';

interface UseMultiSelectChipsOverflowPopoverParams {
    stopOverflowPropagation: boolean;
}

interface UseMultiSelectChipsOverflowPopoverResult {
    moreAnchorEl: HTMLElement | null;
    handleMoreClick: (event: MouseEvent<HTMLElement>) => void;
    handleMoreClose: (event?: { stopPropagation?: () => void }) => void;
    stopPropagation: (event: MouseEvent<HTMLElement>) => void;
}

export function useMultiSelectChipsOverflowPopover({
    stopOverflowPropagation
}: UseMultiSelectChipsOverflowPopoverParams): UseMultiSelectChipsOverflowPopoverResult {
    const [moreAnchorEl, setMoreAnchorEl] = useState<HTMLElement | null>(null);

    function handleMoreClick(event: MouseEvent<HTMLElement>) {
        stopPropagation(event);
        setMoreAnchorEl(event.currentTarget as HTMLElement);
    }

    function handleMoreClose(event?: { stopPropagation?: () => void }) {
        if (stopOverflowPropagation) {
            event?.stopPropagation?.();
        }
        setMoreAnchorEl(null);
    }

    return {
        moreAnchorEl,
        handleMoreClick,
        handleMoreClose,
        stopPropagation
    };
}
